/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Card from '../../Reusable/Card';
import { LanguageContext } from '../../../../../libs/Context';
import { getPopularFeeds } from '../../../../actions/feeds_actions_new';
import { feedActionContext } from '../../..';

const PopularFeeds = () =>
{
	const [ expanded, setExpanded ] = useState('panel1');
	// const navigate = useNavigate();
	const { language } = useContext(LanguageContext);
	const [ feedList, setFeedList ] = useState([]);
	const userData = useSelector((state:any) => state.mysession.session);
	const ITEMS_PER_PAGE = 5; // Changed to 5 as per requirement
	const { feedAction } = useContext(feedActionContext);

	// const handleViewAll = (e) =>
	// {
	// 	e.stopPropagation();
	// 	navigate('/news/popularfeeds');
	// };

	const handleChange = (panel) => (event, isExpanded) =>
	{
		setExpanded(isExpanded ? panel : false);
	};

	const getPopularFeedsList = async () =>
	{
		const query = {
			skip  : 0,
			limit : ITEMS_PER_PAGE,
			uid   : userData?.userId,
			comid : userData?.companyId,
			...(userData?.role !== 'individual' && { empRole: userData?.empRole }),
			role  : userData?.role
		};

		try
		{
			const res = await getPopularFeeds(query);

			if (res?.status)
			{
				setFeedList(res?.data);
			}
		}
		catch (err)
		{
			console.error('Error fetching popular feeds:', err);
		}
	};

	useEffect(() =>
	{
		getPopularFeedsList();
	}, [ feedAction?.remove_feed, feedAction?.edit_feed ]);

	if (!feedList?.length) return null;

	return (
		<Grid item width='100%'>
			<Accordion
				expanded={expanded === 'panel1'}
				onChange={handleChange('panel1')}
				sx={{
					width        : 'var(--percent100)',
					borderRadius : '13px !important',
					overflow     : 'hidden'
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					className='helpSupSummary'
					sx={{
						padding          : '24px 16px',
						'&.Mui-expanded' : {
							minHeight : '44px'
						},
						'& .MuiAccordionSummary-expandIconWrapper' : {
							marginLeft : '10px'
						}
					}}
				>
					<Grid container flexWrap='nowrap'>
						<Grid item xs sx={{ minWidth: 0, overflow: 'hidden' }} display='flex' alignItems='center'>
							<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
								<Typography fontWeight='var(--font500)'>
									{language?.PopularFeeds}
								</Typography>
							</Box>
						</Grid>
						{/* In future if it is required then we need to enable this one for more view... */}
						{/* {feedList.length > ITEMS_PER_PAGE && (
							<Grid item sx={{ flexShrink: 0 }} alignItems='start' display='flex'>
								<Typography
									color='primary'
									variant='body2'
									fontWeight='var(--font500)'
									onClick={handleViewAll}
									sx={{ cursor: 'pointer' }}
								>
									{language?.viewAll}
								</Typography>
							</Grid>
						)} */}
					</Grid>
				</AccordionSummary>
				<AccordionDetails sx={{ padding: '0 4px' }}>
					<Grid container >
						{feedList.map((item:any, index:any) => (
							<Grid item xs={12} key={item?._id}>
								<Card
									key={`${item?._id}uniqK${index}`}
									item={item}
									showFooterButtons
									borderstyle='none'
									borderBtm={index === feedList.length - 1 ? 'none' : '1px solid var(--share)'}
									bordeRadius='none'
									borTop='none'
								/>
							</Grid>
						))}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};

export default PopularFeeds;